import { useEffect, useState } from "react";
var useDimensions = function (ref) {
    var _a = useState({
        width: 0,
        height: 0
    }), dimensions = _a[0], setDimensions = _a[1];
    useEffect(function () {
        var getDimensions = function () { return ({
            width: ref.current.offsetWidth,
            height: ref.current.offsetHeight
        }); };
        var handleResize = function () {
            setDimensions(getDimensions());
        };
        if (ref.current) {
            setDimensions(getDimensions());
        }
        window.addEventListener("resize", handleResize);
        return function () {
            window.removeEventListener("resize", handleResize);
        };
    }, [ref]);
    return dimensions;
};
export default useDimensions;
